import * as services from 'services/metrics';

export const SET_ERROR = 'metrics/SET_ERROR';
export const CLEAR_ERROR = 'metrics/CLEAR_ERROR';
export const REQUEST_STARTED = 'metrics/REQUEST_STARTED';
export const REQUEST_COMPLETED = 'metrics/REQUEST_SUCCESSFUL';
export const SET_METRICS = 'metrics/SET_METRICS';
export const SET_METRICS_DURATION = 'metrics/SET_METRICS_DURATION';
export const GET_METRICS_FROM_SERVER = 'metrics/GET_METRICS_FROM_SERVER';
export const SET_RECIPIENT_METRICS = 'metrics/SET_RECIPIENT_METRICS';
export const SET_SERVICE_METRICS = 'metrics/SET_SERVICE_METRICS';
export const GET_SERVICE_METRICS_FROM_SERVER =
  'metrics/GET_SERVICE_METRICS_FROM_SERVER';
export const SET_LINK_METRICS = 'metrics/SET_LINK_METRICS';
export const GET_LINK_METRICS_FROM_SERVER =
  'metrics/GET_LINK_METRICS_FROM_SERVER';

export const setError = error => ({
  type: SET_ERROR,
  error,
});

export const clearError = () => ({
  type: CLEAR_ERROR,
});

export const requestStarted = () => dispatch => {
  dispatch(clearError());
  dispatch({ type: REQUEST_STARTED });
};

export const requestCompleted = () => ({
  type: REQUEST_COMPLETED,
});

export const setMetrics = metrics => ({
  type: SET_METRICS,
  metrics,
});

export const setMetricsDuration = dates => ({
  type: SET_METRICS_DURATION,
  dates,
});

export const setServiceMetrics = serviceMetrics => ({
  type: SET_SERVICE_METRICS,
  serviceMetrics,
});

export const setLinkMetrics = linkMetrics => ({
  type: SET_LINK_METRICS,
  linkMetrics,
});

export const setRecipientMetrics = recipientMetrics => ({
  type: SET_RECIPIENT_METRICS,
  recipientMetrics,
});

export const getMetricsFromServer = (
  startDate,
  endDate,
  category = -1,
  realTime = true,
) => dispatch => {
  dispatch(requestStarted());
  if (realTime) {
    services
      .getMetrics(startDate, endDate, category)
      .then(metrics => {
        if (metrics) dispatch(setMetrics(metrics));
        else dispatch(setError('Error fetching data'));
        dispatch(requestCompleted());
      })
      .catch(error => {
        dispatch(setError(error.message));
        dispatch(requestCompleted());
      });
  } else {
    services
      .getSummary(startDate, endDate, category)
      .then(metrics => {
        if (metrics) dispatch(setMetrics(metrics));
        else dispatch(setError('Error fetching data'));
        dispatch(requestCompleted());
      })
      .catch(error => {
        dispatch(setError(error.message));
        dispatch(requestCompleted());
      });
  }
};

export const getServiceMetricsFromServer = (
  templateId,
  startDate,
  endDate,
) => dispatch => {
  dispatch(requestStarted());
  services
    .getServiceMetrics(templateId, startDate, endDate)
    .then(serviceMetrics => {
      if (serviceMetrics) dispatch(setServiceMetrics(serviceMetrics));
      else dispatch(setError('Error fetching data'));
      dispatch(requestCompleted());
    })
    .catch(error => {
      dispatch(setError(error.message));
      dispatch(requestCompleted());
    });
};

export const getLinkMetricsFromServer = (
  templateId,
  startDate,
  endDate,
) => dispatch => {
  dispatch(requestStarted());
  services
    .getLinkMetrics(templateId, startDate, endDate)
    .then(linkMetrics => {
      if (linkMetrics) dispatch(setLinkMetrics(linkMetrics));
      else dispatch(setError('Error fetching data'));
      dispatch(requestCompleted());
    })
    .catch(error => {
      dispatch(setError(error.message));
      dispatch(requestCompleted());
    });
};

export const getRecipientMetricsFromServer = email => dispatch => {
  dispatch(requestStarted());
  services
    .getRecipientMetrics(email)
    .then(recipientMetrics => {
      if (recipientMetrics) dispatch(setRecipientMetrics(recipientMetrics));
      else dispatch(setError('Error fetching data'));
      dispatch(requestCompleted());
    })
    .catch(error => {
      dispatch(setError(error.message));
      dispatch(requestCompleted());
    });
};
